import { createSlice } from "@reduxjs/toolkit";
import { IClone } from "src/@types/clones";
import { IResponseWithPagination } from "src/@types/api";
import { MY_CLONES_SLICE_NAME } from "./actions";
import {
  changeCloneStatusReducer,
  deleteCloneReducer,
  getMyClonesReducer,
} from "./reducers";

interface IClonesObject {
  isLoading: boolean;
  data: IResponseWithPagination<IClone>;
}

export interface MyClonesState {
  myClones: IClonesObject;
}

const initialState: MyClonesState = {
  myClones: {
    isLoading: false,
    data: null,
  },
};

export const { reducer: myClones } = createSlice({
  name: MY_CLONES_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers(builder) {
    getMyClonesReducer(builder);
    deleteCloneReducer(builder);
    changeCloneStatusReducer(builder);
  },
});
